<template>
  <div
    v-if="isVisible"
    class="sticky inset-x-0 z-40 w-full px-4 py-3"
    :class="[
      promoTheme.backgroundColor,
      promoTheme.textColor,
      {
        'top-0': position == 'top',
        'bottom-0': position == 'bottom',
      }
    ]"
  >
    <div
      class="prose max-w-none text-center prose-p:my-2 md:px-4"
      :class="[promoTheme.prose]"
      v-html="simpleText"
    />
    <button
      type="button"
      class="wc-focus absolute right-1.5 top-1.5 focus-visible:outline-offset-1 lg:right-6 lg:top-1/2 lg:-translate-y-1/2"
      @click="closePromo"
    >
      <span
        class="sr-only"
        v-text="dismissButtonText"
      />
      <IconX
        :size="24"
        aria-hidden="true"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { IconX } from '@tabler/icons-vue'

defineOptions({
  name: 'AppPromotion',
})

const props = withDefaults(defineProps<{
  storageKey: string
  simpleText: string
  promoTheme: {
    textColor: string
    backgroundColor: string
    prose: string
  }
  position: 'top' | 'bottom'
  dismissButtonText?: string
}>(), {
  dismissButtonText: 'Hide Promotion Banner',
})

const isVisible = ref()
const showItAgainAfter = 60 * 60 * 24 // 1 day in seconds
const now = ref(new Date().getTime() / 1000)

onMounted(() => {
  isVisible.value = userHasNotDismissed.value
})

const userHasNotDismissed = computed(() => {
  const dismissedAt = Number(localStorage.getItem(props.storageKey))

  if (!dismissedAt) {
    return true
  }

  return (dismissedAt + showItAgainAfter) < now.value
})

const closePromo = () => {
  localStorage.setItem(props.storageKey, now.value.toString())
  isVisible.value = false
}
</script>
